// extracted by mini-css-extract-plugin
export default {"period":"lB1GutKgUBATDEvY9o5q","night":"SdUI8xTvuziJ8g5dP2kl"};